import { Injectable, inject } from '@angular/core';
import { WINDOW } from '@app/shared/providers/window.provider';
import { asyncScheduler } from 'rxjs';
import { DomService } from 'src/app/core/services/dom/dom.service';
import {
  availableLanguages,
  getCurrentPhraseLanguage,
  Languages,
} from 'src/app/shared/utils/localization';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root',
})
export class FooterService {
  private domService = inject(DomService);
  env = inject(EnvironmentService);
  private window = inject<Window>(WINDOW);

  loadFooters(language: string): void {
    const phraseLanguage = getCurrentPhraseLanguage(language);
    if (this.env.isRoyalCanin) {
      const scriptSrc = availableLanguages.find(
        (x) => x.name === phraseLanguage,
      )?.footerUrl;
      if (scriptSrc) {
        this.domService.loadScript({ src: scriptSrc });
      }

      if (language === Languages.frFR) {
        asyncScheduler.schedule(() => {
          const rcFooter = this.window.document.getElementById('rc-footer');
          if (rcFooter) {
            rcFooter.style.display = 'block';
          }
        });
      }
    }
    if (this.env.isWhiteLabel) {
      const whiteLabelFooter = this.env.getWhileLabelFooter();
      if (whiteLabelFooter) {
        this.domService.loadScript({ src: whiteLabelFooter });
      }
    }
  }
}
